
var _ = require('underscore');
var $ = require('jquery');
var logger = require('loglevel');

const $global = require('../../assets/js/globalElements');
const $body = $global.$body;

export class FeatureFlags {

  constructor() {
    this.features = [];
  }

  register(flag) {
    if (this.byName(flag.flagName)) {
      throw new Error('Feature Flag "' + flag.flagName + '" already registered');
    } else {
      this.features.push(flag);
    }
  }

  byName(flagName) {
    return _.findWhere(this.features, { flagName: flagName });
  }

}

const flags = new FeatureFlags();

export class FeatureFlag {

  constructor(createdDate, flagName) {
    this.createdDate = createdDate;
    this.flagName = flagName;
    flags.register(this);
    this.checkExpired();
  }

  isEnabled() {
    return $body.hasClass('feat-' + this.flagName);
  }

  isOff() {
    return $body.hasClass('no-feat-' + this.flagName);
  }

  checkExpired() {
    try {
      var created = new Date(this.createdDate);
      var monthExpires = created.getMonth() + 3;
      var yearExpires = monthExpires > 12 ? created.getFullYear() + 1 : created.getFullYear();
      var expires = new Date(yearExpires, monthExpires === 12 ? 12 : (monthExpires % 12) - 1);
      var now = (new Date()).getTime();
      if (expires.getTime() < now) {
        logger.trace('Feature "' + this.flagName + '" expired on ' + expires + ' and should either be integrated or removed');
      }
    } catch (err) {}
  }

}

export default flags;



// WEBPACK FOOTER //
// ./uikit/utilities/featureFlags.js